const browserOrigin = typeof window !== 'undefined' && window.location?.origin
  ? window.location.origin
  : 'https://podboss.cchko.cc';

const defaultConfig = {
  authBaseUrl: `${browserOrigin}/auth`,
  apiBaseUrl: `${browserOrigin}/v1`,
  authDisabled: false,
  longRequestTimeoutMs: 10 * 60 * 1000,
};

const resolvedConfig = (() => {
  const windowOverrides = {};
  if (typeof window !== 'undefined' && window.__APP_CONFIG__) {
    if (typeof window.__APP_CONFIG__.authBaseUrl === 'string' && window.__APP_CONFIG__.authBaseUrl) {
      windowOverrides.authBaseUrl = window.__APP_CONFIG__.authBaseUrl;
    }
    if (typeof window.__APP_CONFIG__.authDisabled === 'boolean') {
      windowOverrides.authDisabled = window.__APP_CONFIG__.authDisabled;
    }
    if (typeof window.__APP_CONFIG__.apiBaseUrl === 'string' && window.__APP_CONFIG__.apiBaseUrl) {
      windowOverrides.apiBaseUrl = window.__APP_CONFIG__.apiBaseUrl;
    }
    if (typeof window.__APP_CONFIG__.longRequestTimeoutMs === 'number') {
      windowOverrides.longRequestTimeoutMs = window.__APP_CONFIG__.longRequestTimeoutMs;
    }
  }

  const envOverrides = {};
  if (typeof process !== 'undefined' && process.env) {
    const envUrl = process.env.REACT_APP_AUTH_BASE_URL || process.env.AUTH_BASE_URL;
    if (envUrl) {
      envOverrides.authBaseUrl = envUrl;
    }
    const envApiUrl = process.env.REACT_APP_API_BASE_URL || process.env.API_BASE_URL;
    if (envApiUrl) {
      envOverrides.apiBaseUrl = envApiUrl;
    }
    const rawDisabled = process.env.REACT_APP_AUTH_DISABLED ?? process.env.AUTH_DISABLED;
    if (rawDisabled != null) {
      envOverrides.authDisabled = rawDisabled === 'true' || rawDisabled === '1';
    }
    const rawTimeout = process.env.REACT_APP_LONG_REQUEST_TIMEOUT_MS || process.env.LONG_REQUEST_TIMEOUT_MS;
    if (rawTimeout) {
      const parsed = parseInt(rawTimeout, 10);
      if (!Number.isNaN(parsed) && parsed > 0) {
        envOverrides.longRequestTimeoutMs = parsed;
      }
    }
  }

  return { ...defaultConfig, ...envOverrides, ...windowOverrides };
})();

export default resolvedConfig;
